import { render } from "./UserActivities.vue?vue&type=template&id=92afa5d8"
import script from "./UserActivities.vue?vue&type=script&lang=js"
export * from "./UserActivities.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__